import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
/**
 * Initializes LaunchDarkly React provider dynamically.
 * Returns the provider component (LDProvider) or null if no client id configured.
 */
export async function initLDProvider() {
  
  const clientSideID = `${window.env?.launchDarklyClientId}`;
  if (!clientSideID) return null;

  try {
    const LDProvider = await asyncWithLDProvider({
      clientSideID,
      context: {
        kind: 'multi',
        team: {
          kind: 'team',
          key: 'AUTO_IMMC',
          name: 'AUTO_IMMC'
        },
        app: {
          kind: 'app',
          key: 'CIP',
          name: 'CIP'
        }
      },
      options: {
        bootstrap: 'localStorage',
      },
    });
    return LDProvider;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('LaunchDarkly init failed:', e?.message);
    return null;
  }
}
